
export const CODE_OK = 200 // 请求成功状态码

export const LACK_TOKEN = -800 // token过期或没有token 状态码

export const LACK_PARAMS = -100 // 缺少参数 状态码

export const NUll_PARAMS = -300 // 参数不能为空 状态码
